import React from 'react';
import { Check, Pencil } from 'lucide-react';
import { OptionCardProps } from './types';
import { cn } from '@/lib/utils';

export const OptionCard: React.FC<OptionCardProps> = ({
  text,
  badge,
  isSelected = false,
  onClick,
  variant = 'default',
}) => {
  if (variant === 'custom') {
    return (
      <button
        onClick={onClick}
        className={cn(
          'w-full p-4 text-left rounded-lg border-2 border-dashed transition-all',
          'flex items-center gap-3',
          'border-[var(--pm-border-default)] hover:border-[var(--pm-cyan-border)] hover:bg-[var(--pm-bg-card)]'
        )}
      >
        <div className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-[var(--pm-bg-card)]">
          <Pencil className="h-4 w-4 text-[var(--pm-text-faint)]" />
        </div>
        <span className="text-sm text-[var(--pm-text-faint)]">Write your own...</span>
      </button>
    );
  }

  const isCurrent = badge === 'current';

  return (
    <button
      onClick={onClick}
      className={cn(
        'w-full p-3 text-left rounded-lg border-2 transition-all',
        'flex items-start gap-3',
        isSelected
          ? 'border-cyan-500 bg-cyan-500/10'
          : isCurrent
          ? 'border-dashed border-[var(--pm-border-emphasis)] hover:border-[var(--pm-cyan-border)]'
          : 'border-[var(--pm-border-default)] hover:border-[var(--pm-cyan-border)]'
      )}
    >
      {/* Badge */}
      <div className="shrink-0 mt-0.5">
        {isCurrent ? (
          <span className="inline-block px-2 py-0.5 text-[10px] font-medium rounded bg-green-500/20 text-green-500">
            Current
          </span>
        ) : (
          <span className="w-6 h-6 flex items-center justify-center text-xs font-medium rounded-full bg-[var(--pm-bg-card)] text-[var(--pm-cyan-text)]">
            {badge}
          </span>
        )}
      </div>

      {/* Text */}
      <span className={cn('text-sm flex-1', isCurrent ? 'text-[var(--pm-text-faint)]' : 'text-[var(--pm-text-primary)]')}>
        {text}
      </span>

      {/* Selected Checkmark */}
      {isSelected && (
        <div className="shrink-0 mt-0.5">
          <Check className="h-5 w-5 text-cyan-500" />
        </div>
      )}
    </button>
  );
};
